"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var crypto = __importStar(require("crypto"));
/**
 * A user, who can be the creator of a {@link Task}, or assigned to it for example
 */
var User = /** @class */ (function () {
    /**
     * @param email - This user email
     * @param username - A username (or login) for this user
     * @param url - The URL to this user (directly usable in an `<a>` href)
     * @param _avatarUrl - An URL directly usable in an img src
     */
    function User(email, username, url, _avatarUrl) {
        if (url === void 0) { url = null; }
        this.email = email;
        this.username = username;
        this.url = url;
        if (!_avatarUrl) {
            var usedEmail = email ? email : '';
            var emailHash = crypto
                .createHash('md5')
                .update(usedEmail.trim().toLowerCase())
                .digest('hex');
            this.avatarUrl = "https://www.gravatar.com/avatar/" + emailHash + "?s=200&d=mp";
        }
        else {
            this.avatarUrl = _avatarUrl;
        }
    }
    return User;
}());
exports.User = User;
//# sourceMappingURL=User.js.map